import { api } from "lib";
import apiFormData from "lib/apiFormData";

export const getRole = async (params) => {
    return await api.post("/v1/dropdown/getAllRoleByCompanyId", params);
};

export const getEmploymentType = async (params) => {
    return await api.post("/v1/dropdown/getPosition", params);
};

export const getDepartment = async (params) => {
    return await api.post("/v1/dropdown/getStmDepartment", params);
};

export const getWorkInLocation = async (params) => {
    return await api.post("/v1/workInLocation/getWorkInLocationInCompany", params);
};
export const getEmploymentTypeSetup = async (params) => {
    return await api.post("/v1/employmentTypeSetup/getEmploymentTypeSetup", params);
};

export const updateStatus = async (params) => {
    return await api.post("/v1/payment/updateStatus", params);
}
export const transfersToTemp = async (params) => {
    return await api.post("/v1/payrollPeriod/transfersToTemp", params);
}

export const getPayrollPeriod = async (params) => {
    return await api.post("/v1/payment/getPayrollPeriod", params);
}

export const getEmployeePayment = async (params) => {
    return await api.post("/v1/payment/getEmployeePaymentPagination", params);
}
export const getEmployeeGroupCalculationInfo = async (params) => {
    return await api.post("/v1/payment/getEmployeeGroupCalculationInfo", params);
}

export const getEmployeeByTab = async (params) => {
    return await api.post("/v1/payment/getEmployeeByTab", params);
}

export const editPayment = async (params) => {
    return await api.post("/v1/payment/createPayment", { ...params, timeout: 999999999 });
}

export const updatePayment = async (params) => {
    return await api.post("/v1/payment/editPayment", params);
}

export const updatePaymentDate = async (params) => {
    return await api.post("/v1/payment/updatePaymentDate", params)
}
export const updateOvertimePaymentDate = async (params) => {
    return await api.post("/v1/payment/updateOvertimePaymentDate", params)
}

export const returnPayment = async (params) => {
    return await api.post("/v1/payment/returnPayrollPayment", params)
}
export const rejectedPayment = async (params) => {
    return await api.post("/v1/payment/rejectedEmployeePayment", params)
}
export const getEmployeeIncomeDeductionByTxnPaymentId = async (params) => {
    return await api.post("/v1/payment/getEmployeeIncomeDeductionInPeriod", params)
}
export const getEmploymentIncomeDeductionByPayrollId = async (params) => {
    return await api.post("/v1/payrollPeriod/getEmploymentIncomeDeductionById", params)
}

export const previewEditEmployeeIncomeDeductInPeriod = async (params) => {
    return await api.post("/v1/payment/previewEditEmployeeIncomeDeductInPeriod", params)
}


// * use
export const getEmployeeByApproveStatus = async (params) => {
    return await api.post("/v1/payment/getEmployeePaymentPagination", params)
}


// * updateStatus
export const updateHeaderStatusToVerification = async (params) => {
    return await api.post("/v1/payment/updateHeaderStatusToVerification", params)
}
export const updateHeaderStatusToApproval = async (params) => {
    return await api.post("/v1/payment/updateHeaderStatusToApproval", params)
}
export const updateHeaderStatusToCal = async (params) => {
    return await api.post("/v1/payment/updateHeaderStatusToCal", params)
}
export const updateHeaderStatusToClose = async (params) => {
    return await api.post("/v1/payment/updateHeaderStatusToClose", params)
}
export const updateHeaderStatusToPayment = async (params) => {
    return await api.post("/v1/payment/updateHeaderStatusToPayment", params)
}
export const updateHeaderStatusToPaid = async (params) => {
    return await api.post("/v1/payment/updateHeaderStatusToPaid", params)
}
export const updateTxnPaymentEmployeeIncomeDeduct = async (params) => {
    return await api.post("/v1/payment/updateTxnPaymentEmployeeIncomeDeduct", params)
}
export const updateStatusToReject = async (params) => {
    return await api.post("/v1/payment/updateStatusToReject", params)
}
export const updateStatusToPending = async (params) => {
    return await api.post("/v1/payment/updateStatusToPending", params)
}
export const updateStatusToCalculate = async (params) => {
    return await api.post("/v1/payment/updateStatusToCalculate", params)
}
export const countTxnPaymentByStatus = async (params) => {
    return await api.post("/v1/payment/countTxnPaymentByStatus", params)
}

export const sendingSalaryCertificate = async (params) => {
    return await api.post("/v1/payment/sendingSalaryCertificate", params)
}
export const sendingSalaryCertificateById = async (params) => {
    return await api.post("/v1/payment/sendingSalaryCertificateById", params)
}

export const exportPayment = async (params) => {
    return await api.post("/v1/payment/exportPayment", params, {
        responseType: 'blob'
    })
}


export const exportPaymentBBL = async (params) => {
    return await api.post("/v1/payment/exportPaymentBBL", params, {
        responseType: 'blob'
    })
}

export const getCompany = async (params = {}) => {
    return await api.post("/v1/company/getCompany", params);
};

export const geIncomeDeductionByStpEmploymentTypeForSetup = async (params) => {
    return await api.post("/v1/payment/getEmploymentIncomeDeductionSetup", params)
}
export const getEmploymentTypeIncomeDeductionSetupTxn = async (params) => {
    return await api.post("/v1/payment/getEmploymentTypeIncomeDeductionSetupTxn", params)
}

export const getStpEmployeeIncomeDeductionByEmployeeId = async (params) => {
    return await api.post("/v1/payment/getStpEmployeeIncomeDeduction", params)
}

export const exportTxnPaymentByTxnPayrollPeriodId = async (params) => {
    return await api.post("/v1/payment/exportTxnPaymentByTxnPayrollPeriodId", { ...params, timeout: 999999999 }, { responseType: 'blob' });
}

export const exportEmployeePaySlip = async (params) => {
    return await api.post("v1/payment/downloadSlipPaySlipById", { ...params, timeout: 999999999 }, { responseType: 'blob' });
}

export const exportPaySlipByTxnPaymentId = async (params) => {
    return await api.post("/v1/payment/downloadPaySlipByTxnPaymentId", { ...params, timeout: 999999999 }, { responseType: 'blob' });
}

export const getOvertimeInPeriod = async (params) => {
    return await api.post("/v1/payment/getOvertimeInPeriod", params)
}

export const getEmployeeGroupCalculationPaging = async (params) => {
    return await api.post("/v1/payment/getEmployeeGroupCalculationPaging", { ...params, timeout: 999999999 })
}
export const previewGroupCalculation = async (params) => {
    return await api.post("/v1/payment/previewGroupCalculation", { ...params, timeout: 999999999 })
}
export const updateEmployeeGroupCalculation = async (params) => {
    return await api.post("/v1/payment/updateEmployeeGroupCalculation", params)
}

export const exportTextFile = async (params) => {
    return await api.post("/v1/payment/exportTextFilePaymentForBank", params, {
        responseType: 'blob'
    })
}